import React, { useState, useRef } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const WorkoutsSignupForm = ({ source, buttonLabel = 'Send It', successMessage, testPrefix = 'workouts' }) => {
  const [formData, setFormData] = useState({ name: '', email: '' });
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [honeypot, setHoneypot] = useState('');
  const openedAtRef = useRef(Date.now());

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = 'Name is required';
    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = 'Please enter a valid email';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setSubmitting(true);
    try {
      const response = await fetch(`${API_URL}/api/auth/subscribe`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          first_name: formData.name.split(' ')[0] || formData.name,
          last_name: formData.name.split(' ').slice(1).join(' ') || '',
          email: formData.email,
          phone: '',
          source,
          website: honeypot,
          form_ms: Date.now() - openedAtRef.current
        })
      });
      if (response.ok) setSubmitted(true);
    } catch (err) {
      setSubmitted(true);
    }
    setSubmitting(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  if (submitted) {
    return (
      <div className="workouts-signup-success" data-testid={`${testPrefix}-signup-success`}>
        <p>{successMessage || "You're in! We'll send the next workout straight to your inbox."}</p>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="workouts-signup-form" data-testid={`${testPrefix}-signup-form`}>
      <input
        type="text"
        name="website"
        value={honeypot}
        onChange={(e) => setHoneypot(e.target.value)}
        style={{ position: 'absolute', left: '-9999px', opacity: 0, height: 0, width: 0 }}
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
      />
      <div className="workouts-form-row">
        <div className="workouts-form-group">
          <input
            type="text"
            name="name"
            placeholder="Your name"
            value={formData.name}
            onChange={handleChange}
            className={errors.name ? 'error' : ''}
            data-testid={`${testPrefix}-name-input`}
          />
          {errors.name && <span className="error-message">{errors.name}</span>}
        </div>

        <div className="workouts-form-group">
          <input
            type="email"
            name="email"
            placeholder="Your email"
            value={formData.email}
            onChange={handleChange}
            className={errors.email ? 'error' : ''}
            data-testid={`${testPrefix}-email-input`}
          />
          {errors.email && <span className="error-message">{errors.email}</span>}
        </div>

        <button
          type="submit"
          disabled={submitting}
          className="workouts-submit-btn"
          data-testid={`${testPrefix}-submit-btn`}
        >
          {submitting ? 'Sending...' : buttonLabel}
        </button>
      </div>
    </form>
  );
};
